import { render } from "./Index.vue?vue&type=template&id=853447ea&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=853447ea&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853447ea"],['__file',"src/assets/js/pages/AddMeterConfig/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "853447ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('853447ea', __exports__)) {
    api.reload('853447ea', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=853447ea&scoped=true", () => {
    api.rerender('853447ea', render)
  })

}


export default __exports__